import React from 'react';
import { Flag } from 'lucide-react';
import { reportIssue } from '../../utils/diagnosticsBuffer';

/**
 * Contextual "Report this issue" CTA. Render it ONLY while a risk condition
 * is true - it must never be a permanent fixture. Clicking captures a page
 * screenshot + diagnostics and opens the AI-prefilled report modal.
 */
export const ReportIssueButton = ({
  issueContext = {},
  fingerprint = null,
  label = 'Report this issue',
  variant = 'inline', // 'inline' | 'banner' | 'subtle'
  className = '',
  testId = 'report-issue-btn',
}) => {
  const onClick = (e) => {
    e.stopPropagation();
    reportIssue(issueContext, fingerprint);
  };

  if (variant === 'banner') {
    return (
      <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        className={`w-full flex items-center justify-center gap-2 px-3 py-2 rounded-md border border-rose-300 bg-rose-50 hover:bg-rose-100 text-rose-700 text-xs font-semibold transition-colors ${className}`}
      >
        <Flag className="w-3.5 h-3.5" />
        {label}
      </button>
    );
  }

  if (variant === 'subtle') {
    return (
      <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        className={`inline-flex items-center gap-1 text-[11px] font-semibold text-rose-600 hover:text-rose-800 underline underline-offset-2 transition-colors ${className}`}
      >
        <Flag className="w-3 h-3" />
        {label}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md border border-rose-300 bg-white hover:bg-rose-50 text-rose-700 text-xs font-semibold transition-colors ${className}`}
    >
      <Flag className="w-3.5 h-3.5" />
      {label}
    </button>
  );
};

export default ReportIssueButton;
